import React from 'react';
import DashboardLayout from '../userLayout/userLayout';
import PublicJobLayout from '../publicJobLayout/PublicJobLayout';
import { isSessionRecoverable } from '../../components/ProtectedRoute';

// job-detail/:id is reachable both by logged-in users and by guests who
// open a shared link. DashboardLayout fetches the user's profile on mount
// (an auth-only call), which would 401 and force-redirect a guest straight
// to /login via the global response interceptor — so guests get the same
// lightweight chrome the public /jobs/:slug page already uses instead.
const JobDetailLayout = () => {
  return isSessionRecoverable() ? <DashboardLayout /> : <PublicJobLayout />;
};

export default JobDetailLayout;
